import {createFileRoute, notFound} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {getAdminWorkspacesWithCaching} from "../../../-queries";
import {fetchDatasetDetails} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/debugger/-api";
import {ErrorComponent} from "../../../-errorComponent";
import {NotFoundComponent} from "../../../-notFoundComponent";
import {PendingComponent} from "../../../-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace/$workspaceId/datasets/$datasetId",
)({
    loader: async ({context, params}) => {
        const workspaceIdResult = uuidZodValidator.safeParse(params.workspaceId);
        const datasetIdResult = uuidZodValidator.safeParse(params.datasetId);
        if (workspaceIdResult.success !== true || datasetIdResult.success !== true) {
            throw notFound();
        }

        const workspaceId = workspaceIdResult.data;
        const datasetId = datasetIdResult.data;
        const accessToken = context.authenticationStatus.accessToken;
        const intellsysBaseUrl = context.intellsysBaseUrl;

        const [workspaces, datasetDetailsResult] = await Promise.all([
            getAdminWorkspacesWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl,
                accessToken,
            }),
            fetchDatasetDetails({
                accessToken,
                datasetId,
                intellsysBaseUrl,
                workspaceId,
            }),
        ]);

        const workspace = workspaces.find((item) => item.id === workspaceId);
        if (workspace === undefined) {
            throw notFound();
        }
        if (datasetDetailsResult.success !== true) {
            throw datasetDetailsResult.error;
        }

        return {
            accessToken,
            dataset: datasetDetailsResult.data,
            datasetId,
            intellsysBaseUrl,
            workspace,
            workspaceId,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
